import { defineComponent, h, computed, ref, onUnmounted } from 'vue';
import { Icon } from '@/ui/components/icon/Icon';
import { box } from '@/ui/components';
import { informationBoxProps, InformationBoxProps } from '@/ui/pages/issue/issueEditWithLog/types';
import { VNodeData } from 'vue/types/vnode.d';
import { inspectionReportModal } from '@/ui/pages/inspection/InspectionReportModal';
import { EventBus } from '@/ui/EventBus';
import { Events } from '@/ui/events';
import { t } from '@/ui/i18n/i18n';

export const InformationBoxSeeReport = defineComponent<InformationBoxProps>({
  name: 'InformationBoxSeeReport',
  props: informationBoxProps,
  setup(props) {
    const hasEmptyTitle = computed(() => props.issue.data.inspection!.title === '');

    const isModalOpen = ref(false);

    const openModal = () => {
      isModalOpen.value = true;
    };

    const closeModal = () => {
      isModalOpen.value = false;
    };

    const unregisterEvents = () => {
      EventBus.$off(Events.seeMoreDetailsIssue, openModal);
    };

    EventBus.$on(Events.seeMoreDetailsIssue, openModal);

    onUnmounted(unregisterEvents);

    return function render() {
      if (props.issue.data.inspection === null) {
        return null;
      }

      return h('div', [
        inspectionReportModal({
          props: {
            active: isModalOpen.value,
            inspectionId: props.issue.data.inspection!.id,
          },
          on: { 'modal:close': closeModal },
        }),
        box([
          h(Icon, {
            props: {
              icon: 'file-exclamation',
              iconPack: 'far',
            },
          }),
          h('span', { class: 'd-inline-block ml-2' }, [
            t('issues.attached-form'),
          ]),
          h('span', { class: 'issue-with-logs__report-title', on: { click: openModal } }, [
            hasEmptyTitle.value
              ? '----'
              : props.issue.data.inspection!.title,
          ]),
        ], { class: 'issue-with-logs__information-box' }),
      ]);
    };
  },
});

export function informationBoxSeeReport(data: VNodeData & { props: InformationBoxProps }) {
  return h(InformationBoxSeeReport, data);
}
